export default __webpack_public_path__ + "static/media/cosmos.19ad0934.jpg";